<template>
  <div>
    <div class="pdf-controller" v-if="controlVisible">
      <div class="pdf-controller-inner">
        <button  class="btn btn-sm navigationButtons" @click="toggleViewMode">
          <span v-if="isSinglePageView"><svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px"
              viewBox="0 0 24 24" fill="none">
              <path stroke="#fff" stroke-linejoin="round" stroke-width="2"
                d="M13 3V10H20M6 7H5C4.44772 7 4 7.44772 4 8V20C4 20.5523 4.44772 21 5 21H14C14.5523 21 15 20.5523 15 20V19M8 4V16C8 16.5523 8.44772 17 9 17H19C19.5523 17 20 16.5523 20 16V9.38898C20 9.13879 19.9062 8.89769 19.7372 8.71326L14.7973 3.32428C14.6078 3.11765 14.3404 3 14.0601 3H9C8.44772 3 8 3.44772 8 4Z" />
            </svg></span>
          <span v-else><svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24"
              fill="none">
              <path fill-rule="evenodd" clip-rule="evenodd"
                d="M6 1C4.34315 1 3 2.34315 3 4V20C3 21.6569 4.34315 23 6 23H18C19.6569 23 21 21.6569 21 20V8.82843C21 8.03278 20.6839 7.26972 20.1213 6.70711L15.2929 1.87868C14.7303 1.31607 13.9672 1 13.1716 1H6ZM5 4C5 3.44772 5.44772 3 6 3H12V8C12 9.10457 12.8954 10 14 10H19V20C19 20.5523 18.5523 21 18 21H6C5.44772 21 5 20.5523 5 20V4ZM18.5858 8L14 3.41421V8H18.5858Z"
                fill="#fff" />
            </svg></span>
        </button>
        <div v-if="isSinglePageView" style="display: flex; flex-direction: row; gap: 5px; flex-wrap: wrap;">
          <button class="btn btn-sm navigationButtons" type="button" @click="prevPage"
            :disabled="currentPage === 1 "><svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px"
              viewBox="0 0 24 24" fill="none">
              <path d="M15 6L9 12L15 18" stroke="#fff" stroke-width="2" stroke-linecap="round"
                stroke-linejoin="round" />
            </svg></button>
          <button class="btn btn-sm navigationButtons" type="button" @click="nextPage"
            :disabled="currentPage === totalPages "><svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px"
              viewBox="0 0 24 24" fill="none">
              <path d="M9 6L15 12L9 18" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            </svg></button>
          <button class="btn btn-sm navigationButtons" type="button" @click="zoomIn" > <svg
              xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px"
              viewBox="0 0 24 24" version="1.1">
              <g id="页面-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                <g id="File" transform="translate(-816.000000, -96.000000)" fill-rule="nonzero">
                  <g id="zoom_in_line" transform="translate(816.000000, 96.000000)">
                    <path
                      d="M24,0 L24,24 L0,24 L0,0 L24,0 Z M12.5934901,23.257841 L12.5819402,23.2595131 L12.5108777,23.2950439 L12.4918791,23.2987469 L12.4918791,23.2987469 L12.4767152,23.2950439 L12.4056548,23.2595131 C12.3958229,23.2563662 12.3870493,23.2590235 12.3821421,23.2649074 L12.3780323,23.275831 L12.360941,23.7031097 L12.3658947,23.7234994 L12.3769048,23.7357139 L12.4804777,23.8096931 L12.4953491,23.8136134 L12.4953491,23.8136134 L12.5071152,23.8096931 L12.6106902,23.7357139 L12.6232938,23.7196733 L12.6232938,23.7196733 L12.6266527,23.7031097 L12.609561,23.275831 C12.6075724,23.2657013 12.6010112,23.2592993 12.5934901,23.257841 L12.5934901,23.257841 Z M12.8583906,23.1452862 L12.8445485,23.1473072 L12.6598443,23.2396597 L12.6498822,23.2499052 L12.6498822,23.2499052 L12.6471943,23.2611114 L12.6650943,23.6906389 L12.6699349,23.7034178 L12.6699349,23.7034178 L12.678386,23.7104931 L12.8793402,23.8032389 C12.8914285,23.8068999 12.9022333,23.8029875 12.9078286,23.7952264 L12.9118235,23.7811639 L12.8776777,23.1665331 C12.8752882,23.1545897 12.8674102,23.1470016 12.8583906,23.1452862 L12.8583906,23.1452862 Z M12.1430473,23.1473072 C12.1332178,23.1423925 12.1221763,23.1452606 12.1156365,23.1525954 L12.1099173,23.1665331 L12.0757714,23.7811639 C12.0751323,23.7926639 12.0828099,23.8018602 12.0926481,23.8045676 L12.108256,23.8032389 L12.3092106,23.7104931 L12.3186497,23.7024347 L12.3186497,23.7024347 L12.3225043,23.6906389 L12.340401,23.2611114 L12.337245,23.2485176 L12.337245,23.2485176 L12.3277531,23.2396597 L12.1430473,23.1473072 Z"
                      id="MingCute" fill-rule="nonzero"></path>
                    <path
                      d="M10.5,2 C15.1944,2 19,5.80558 19,10.5 C19,12.3700235 18.3961412,14.098937 17.372756,15.5024913 L17.176,15.7618 L20.8284,19.4142 C21.2189,19.8047 21.2189,20.4379 20.8284,20.8284 C20.4679385,21.1888615 19.9006793,21.2165893 19.5084027,20.9115834 L19.4142,20.8284 L15.7618,17.176 C14.3145,18.3183 12.4869,19 10.5,19 C5.80558,19 2,15.1944 2,10.5 C2,5.80558 5.80558,2 10.5,2 Z M10.5,4 C6.91015,4 4,6.91015 4,10.5 C4,14.0899 6.91015,17 10.5,17 C14.0899,17 17,14.0899 17,10.5 C17,6.91015 14.0899,4 10.5,4 Z M10.5,6 C11.01285,6 11.4355092,6.38604429 11.4932725,6.88337975 L11.5,7 L11.5,9.5 L14,9.5 C14.5523,9.5 15,9.94772 15,10.5 C15,11.01285 14.613973,11.4355092 14.1166239,11.4932725 L14,11.5 L11.5,11.5 L11.5,14 C11.5,14.5523 11.0523,15 10.5,15 C9.98716857,15 9.56449347,14.613973 9.5067278,14.1166239 L9.5,14 L9.5,11.5 L7,11.5 C6.44772,11.5 6,11.0523 6,10.5 C6,9.98716857 6.38604429,9.56449347 6.88337975,9.5067278 L7,9.5 L9.5,9.5 L9.5,7 C9.5,6.44772 9.94772,6 10.5,6 Z"
                      id="形状" fill="#fff"></path>
                  </g>
                </g>
              </g>
            </svg></button>
          <button class="btn btn-sm navigationButtons" type="button" @click="zoomOut"> <svg
              xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px"
              viewBox="0 0 24 24" version="1.1">
              <g id="页面-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                <g id="File" transform="translate(-864.000000, -96.000000)" fill-rule="nonzero">
                  <g id="zoom_out_line" transform="translate(864.000000, 96.000000)">
                    <path
                      d="M24,0 L24,24 L0,24 L0,0 L24,0 Z M12.5934901,23.257841 L12.5819402,23.2595131 L12.5108777,23.2950439 L12.4918791,23.2987469 L12.4918791,23.2987469 L12.4767152,23.2950439 L12.4056548,23.2595131 C12.3958229,23.2563662 12.3870493,23.2590235 12.3821421,23.2649074 L12.3780323,23.275831 L12.360941,23.7031097 L12.3658947,23.7234994 L12.3769048,23.7357139 L12.4804777,23.8096931 L12.4953491,23.8136134 L12.4953491,23.8136134 L12.5071152,23.8096931 L12.6106902,23.7357139 L12.6232938,23.7196733 L12.6232938,23.7196733 L12.6266527,23.7031097 L12.609561,23.275831 C12.6075724,23.2657013 12.6010112,23.2592993 12.5934901,23.257841 L12.5934901,23.257841 Z M12.8583906,23.1452862 L12.8445485,23.1473072 L12.6598443,23.2396597 L12.6498822,23.2499052 L12.6498822,23.2499052 L12.6471943,23.2611114 L12.6650943,23.6906389 L12.6699349,23.7034178 L12.6699349,23.7034178 L12.678386,23.7104931 L12.8793402,23.8032389 C12.8914285,23.8068999 12.9022333,23.8029875 12.9078286,23.7952264 L12.9118235,23.7811639 L12.8776777,23.1665331 C12.8752882,23.1545897 12.8674102,23.1470016 12.8583906,23.1452862 L12.8583906,23.1452862 Z M12.1430473,23.1473072 C12.1332178,23.1423925 12.1221763,23.1452606 12.1156365,23.1525954 L12.1099173,23.1665331 L12.0757714,23.7811639 C12.0751323,23.7926639 12.0828099,23.8018602 12.0926481,23.8045676 L12.108256,23.8032389 L12.3092106,23.7104931 L12.3186497,23.7024347 L12.3186497,23.7024347 L12.3225043,23.6906389 L12.340401,23.2611114 L12.337245,23.2485176 L12.337245,23.2485176 L12.3277531,23.2396597 L12.1430473,23.1473072 Z"
                      id="MingCute" fill-rule="nonzero"></path>
                    <path
                      d="M10.5,2 C15.1944,2 19,5.80558 19,10.5 C19,12.4869 18.3183,14.3145 17.176,15.7618 L20.8284,19.4142 C21.2189,19.8047 21.2189,20.4379 20.8284,20.8284 C20.4379,21.2189 19.8047,21.2189 19.4142,20.8284 L15.7618,17.176 C14.3145,18.3183 12.4869,19 10.5,19 C5.80558,19 2,15.1944 2,10.5 C2,5.80558 5.80558,2 10.5,2 Z M10.5,4 C6.91015,4 4,6.91015 4,10.5 C4,14.0899 6.91015,17 10.5,17 C14.0899,17 17,14.0899 17,10.5 C17,6.91015 14.0899,4 10.5,4 Z M14,9.5 C14.5523,9.5 15,9.94772 15,10.5 C15,11.0523 14.5523,11.5 14,11.5 L7,11.5 C6.44772,11.5 6,11.0523 6,10.5 C6,9.94772 6.44772,9.5 7,9.5 L14,9.5 Z"
                      id="形状" fill="#fff"></path>
                  </g>
                </g>
              </g>
            </svg></button>
            <button class="btn btn-sm navigationButtons" type="button" @click="rotate(1)"><svg
              xmlns="http://www.w3.org/2000/svg" fill="#fff" width="24px" height="24px" viewBox="0 0 1920 1920">
              <path fill-rule="evenodd" clip-rule="evenodd"
                d="M639.999 209.777h116.019L621.665 75.425 697.09 0l263.111 263.111-260.196 260.196-75.425-75.424 131.439-131.439h-116.02c-176.731 0-320 143.269-320 320H213.332c0-235.642 191.025-426.667 426.667-426.667Zm0 643.556c0-117.82 95.512-213.333 213.333-213.333h853.338c117.82 0 213.33 95.513 213.33 213.333v853.337c0 117.82-95.51 213.33-213.33 213.33H853.332c-117.821 0-213.333-95.51-213.333-213.33V853.333Zm213.333-106.666h853.338c58.91 0 106.66 47.756 106.66 106.666v853.337c0 58.91-47.75 106.66-106.66 106.66H853.332c-58.91 0-106.667-47.75-106.667-106.66V853.333c0-58.91 47.757-106.666 106.667-106.666Z" />
            </svg></button>
            <button class="btn btn-sm navigationButtons" type="button" @click="rotate(2)"><svg xmlns="http://www.w3.org/2000/svg" fill="#fff" width="24px" height="24px" viewBox="0 0 1920 1920">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M1251.45 447.883 1120 316.432h160c176.73 0 320 143.269 320 320h106.67c0-235.641-191.03-426.666-426.67-426.666h-159.97l134.34-134.341L1178.94 0 915.833 263.111l260.197 260.196 75.42-75.424Zm28.55 405.45C1280 735.513 1184.49 640 1066.67 640H213.333C95.513 640 0 735.513 0 853.333v853.337C0 1824.49 95.513 1920 213.333 1920h853.337c117.82 0 213.33-95.51 213.33-213.33V853.333Zm-213.33-106.666H213.333c-58.91 0-106.666 47.756-106.666 106.666v853.337c0 58.91 47.756 106.66 106.666 106.66h853.337c58.91 0 106.66-47.75 106.66-106.66V853.333c0-58.91-47.75-106.666-106.66-106.666Z"/>
              </svg>
            </button>
        </div>
      </div>
    </div>
    <div v-if="isSinglePageView" class="pdf-controller-2">
      <div class="pdf-controller-inner-2">
        <input type="number" v-model.number="goToPage"
          @input="handlePageInput"  :min="1" :max="totalPages"> / {{ totalPages }}
      </div>
    </div>
    <div v-if="isLoading" class="loading-overlay">
      <div class="loading-spinner"></div>
      <p>Yükleniyor...</p>
    </div>
    <div
      ref="pdfContainer"
      class="pdf-touch-container"
      :style="pinchStyle"
      @touchstart="onTouchStart"
      @touchmove="onTouchMove"
      @touchend="onTouchEnd"
      @touchcancel="onTouchEnd"
    >
      <div v-if="isSinglePageView" :style="{ transform: rotationStyle }">
        <canvas :ref="'pdfCanvas' + currentPage" ></canvas>
        <div class="textLayer"></div>
      </div>
      <div v-else v-for="(page, index) in pages" :key="index">
        <canvas :ref="'pdfCanvas' + index"></canvas>
        <div class="textLayer"></div>
      </div>
    </div>
  </div>
</template>

<script>
import * as pdfjsLib from 'pdfjs-dist';
import './styles/pdf_viewer.css'

export default {
  props: {
    pdfUrl: null,
    controlVisible: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    rotationStyle() {
      return `rotate(${this.rotation}deg)`;
    },
    pinchStyle() {
      return {
        transform: `scale(${this.pinchScale})`,
        transformOrigin: `${this.pinchOriginX}% ${this.pinchOriginY}%`,
      };
    }
  },
  name: 'PdfViewer',
  data() {
    return {
      pages: [], // Array to store page references
      totalPages: 0,
      isLoading: true,
      renderingPages: [], // Track which pages are rendering
      currentPage: 1,
      isSinglePageView: false,
      zoomLevel: 1,
      fitToWidth: true, // open fitted to the screen width until the user zooms manually
      rotation: 0,
      pdf: null,
      goToPage: 1,
      devicePixelRatio: window.devicePixelRatio || 1,
      isPinching: false,
      pinchScale: 1,
      pinchOriginX: 50,
      pinchOriginY: 50,
      pinchStartDistance: 0,
      pinchStartZoom: 1,
    };
  },
  mounted() {
    this.loadPdf();
    window.addEventListener('resize', this.handleResize);
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.handleResize);
  },

  methods: {
    handlePageInput() {
      if(this.goToPage > this.totalPages)
        this.goToPage = this.totalPages
      this.loadPdf(this.goToPage);
    },
    handleResize() {
      this.devicePixelRatio = window.devicePixelRatio || 1;
      this.loadPdf(this.currentPage);
    },
    async loadPdf(pageNum = 1) {
      this.isLoading = true
      try {
        // Set the worker to use for loading PDFs
        pdfjsLib.GlobalWorkerOptions.workerSrc = window.location.origin + '/js/pdf.worker.min.js';
        let loadingTask = null;
        let pdf = null;
        if (this.pdf == null) {
          // Load PDF document
          loadingTask = pdfjsLib.getDocument(this.pdfUrl);
          pdf = await loadingTask.promise;
          this.pdf = pdf
        }
        pageNum = Number(pageNum);
        if (this.fitToWidth) {
          await this.applyFitToWidthZoom(pageNum);
        }
        this.currentPage = pageNum;
        const numPages = this.pdf.numPages;
        this.totalPages = this.pdf.numPages
        this.pages = Array.from({ length: numPages }, (_, i) => i + 1); // Create an array of page numbers
        if (this.isSinglePageView) {
          await this.renderPage(this.pdf, pageNum);
          this.isLoading = false
        } else {
          for (let pageNum = 1; pageNum <= this.totalPages; pageNum++) {
            await this.renderPage(this.pdf, pageNum);
            this.isLoading = false
          }
        }

      } catch {
        this.isLoading = false

      }

    },
    // Sets zoomLevel so the page width exactly fills the viewer width
    async applyFitToWidthZoom(pageNum) {
      const page = await this.pdf.getPage(pageNum);
      const pageWidth = page.getViewport({ scale: 1 }).width;
      const canvasBorder = 2; // 1px border on each side of the canvas
      const availableWidth = this.$el.clientWidth - canvasBorder;
      if (pageWidth > 0 && availableWidth > 0) {
        // canvas css width = pageWidth * zoomLevel / devicePixelRatio
        this.zoomLevel = (availableWidth * this.devicePixelRatio) / pageWidth;
      }
    },
    async renderPage(pdf, pageNum) {
      const page = await pdf.getPage(pageNum);

      let canvas = null;
      let textLayerDiv = null;
      if (this.isSinglePageView) {
        canvas = this.$refs['pdfCanvas' + pageNum];
        textLayerDiv = canvas.parentNode.querySelector('.textLayer');
      } else {
        canvas = this.$refs['pdfCanvas' + (pageNum - 1)][0];
        textLayerDiv = canvas.parentNode.querySelector('.textLayer');
      }

      const context = canvas.getContext('2d');
      
      console.log(this.zoomLevel,this.devicePixelRatio)
      const viewport = page.getViewport({ scale: this.zoomLevel });
      canvas.height = viewport.height;
      canvas.width = viewport.width;
      
      canvas.style.width = `${viewport.width / this.devicePixelRatio}px`;
      canvas.style.height = `${viewport.height / this.devicePixelRatio}px`;

      const renderContext = {
        canvasContext: context,
        viewport: viewport,
      };
      await page.render(renderContext).promise;

      textLayerDiv.innerHTML = '';
      textLayerDiv.style.width = canvas.style.width;
      textLayerDiv.style.height = canvas.style.height;
      textLayerDiv.style.left = `${canvas.offsetLeft}px`;
      textLayerDiv.style.top = `${canvas.offsetTop}px`;
      textLayerDiv.style.setProperty('--scale-factor', this.zoomLevel/this.devicePixelRatio);

      const textContent = await page.getTextContent();
      pdfjsLib.renderTextLayer({
        textContentSource: textContent,
        container: textLayerDiv,
        viewport: viewport,
        textDivs: [],
        enhanceTextSelection: true,
      });
    },
    toggleViewMode() {
      this.isSinglePageView = !this.isSinglePageView;
      if (this.isSinglePageView) {
        this.currentPage = 1
        this.renderPage(this.pdf, 1)
      }
      else
        this.loadPdf()
    },
    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
        this.goToPage = this.currentPage;
        this.loadPdf(this.currentPage);
      }
    },
    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
        this.goToPage = this.currentPage;
        this.loadPdf(this.currentPage);
      }
    },
    zoomIn() {
      this.fitToWidth = false;
      this.zoomLevel += 0.5;
      this.loadPdf(this.currentPage);
    },
    zoomOut() {
      if (this.zoomLevel > 0.25) {
        this.fitToWidth = false;
        this.zoomLevel = Math.max(this.zoomLevel - 0.5, 0.25);
        this.loadPdf(this.currentPage);
      }
    },
    rotate(direction = 1) { //1 is right (clockwise) 2 is left (counter-clockwise)
      if(direction == 1)
        this.rotation = (this.rotation + 90) % 360;
      else
        this.rotation = (this.rotation - 90) % 360;

      this.renderPage(this.pdf, this.currentPage);
    },
    getTouchDistance(touches) {
      const dx = touches[0].clientX - touches[1].clientX;
      const dy = touches[0].clientY - touches[1].clientY;
      return Math.sqrt(dx * dx + dy * dy);
    },
    onTouchStart(e) {
      if (e.touches.length === 2) {
        e.preventDefault();
        this.isPinching = true;
        this.pinchStartDistance = this.getTouchDistance(e.touches);
        this.pinchStartZoom = this.zoomLevel;

        const rect = this.$refs.pdfContainer.getBoundingClientRect();
        const midX = (e.touches[0].clientX + e.touches[1].clientX) / 2 - rect.left;
        const midY = (e.touches[0].clientY + e.touches[1].clientY) / 2 - rect.top;
        this.pinchOriginX = rect.width ? (midX / rect.width) * 100 : 50;
        this.pinchOriginY = rect.height ? (midY / rect.height) * 100 : 50;
      }
    },
    onTouchMove(e) {
      if (this.isPinching && e.touches.length === 2) {
        e.preventDefault();
        const distance = this.getTouchDistance(e.touches);
        const scale = distance / this.pinchStartDistance;
        this.pinchScale = Math.min(Math.max(scale, 0.4), 2.5);
      }
    },
    async onTouchEnd(e) {
      if (this.isPinching && e.touches.length < 2) {
        this.isPinching = false;
        const newZoom = Math.min(Math.max(this.pinchStartZoom * this.pinchScale, 0.25), 8);
        this.pinchScale = 1;
        if (Math.abs(newZoom - this.zoomLevel) > 0.01) {
          this.fitToWidth = false;
          this.zoomLevel = newZoom;
          await this.loadPdf(this.currentPage);
        }
      }
    },
  }
};
</script>

<style scoped>
.pdf-touch-container {
  touch-action: pan-x pan-y;
}

canvas {
  border: 1px solid #ddd;
  margin-bottom: 10px;
  position: relative;
}

.pdf-controller,
.pdf-controller-2 {
  position: fixed;
  z-index: 999;
  display: flex;
  flex-direction: row;
  bottom: 20px;
  right: 0;
  left: 0;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease-in-out;
}

.pdf-controller-2 {
  bottom: 70px;
}

.pdf-controller-inner,
.pdf-controller-inner-2 {
  display: flex;
  flex-direction: row;
  padding: 5px;
  padding-left: 5px;
  padding-right: 5px;
  align-items: center;
  gap: 10px;
  box-shadow: 0 2px 8px 4px rgba(0, 0, 0, 0.216);
  background-color: #323232d3;
  color: #ddd;
  border-radius: 4px;
  transition: all 0.2s ease-in-out;
}

.pdf-controller-inner-2 {
  flex-direction: row;

}

.pdf-controller-inner-2 input{
  width: 50px;
  background: transparent;
  border: 1px solid grey;
  border-radius: 4px;
  color: white;
}

.navigationButtons {
  border: 1px solid transparent;
  background-color: rgba(36, 36, 36, 0.06);
  transition: 0.2s all ease-in-out;
}

.navigationButtons:hover {
  background-color: #3b3b3b;
}

.textLayer {
  position: absolute;
  text-align: initial;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  overflow: hidden;
  opacity: 0.2;
  line-height: 1.0;
}

.textLayer .endOfContent {
  display: none;
}

.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.8);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 2;
}

.loading-spinner {
  border: 4px solid #f3f3f3;
  border-top: 4px solid #3498db;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}
</style>